import { AnimatePresence } from "framer-motion";
import React from "react";
import { MenuProvider } from "./src/components/MenuContext";

export function wrapPageElement({ element }) {
  // React needs to be imported in this file. Otherwise gatsby build does not work correctly.
  console.log(React.version);

  return <AnimatePresence mode="wait">{element}</AnimatePresence>;
}

export function wrapRootElement({ element }) {
  return <MenuProvider>{element}</MenuProvider>;
}
